/* istanbul ignore next */
export const defaultHandler: () => void = () => {};
